/* Return focus to the Search button when the Ghost Search dialog closes */
(function () {
    var searchRoot = null;
    var observer = null;
    var lastTrigger = null;
    var wasOpen = false;

    function isSearchOpen() {
        return !!(searchRoot && searchRoot.querySelector('iframe'));
    }

    function handleSearchChange() {
        var open = isSearchOpen();

        if (wasOpen && !open && lastTrigger) {
            var active = document.activeElement;
            var focusLost = !active || active === document.body || active === document.documentElement;

            if (focusLost && lastTrigger.isConnected && lastTrigger.getClientRects().length) {
                lastTrigger.focus({preventScroll: true});
            }

            lastTrigger = null;
        }

        wasOpen = open;
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target && event.target.closest ? event.target.closest('[data-ghost-search]') : null;

        if (!trigger) {
            return;
        }

        searchRoot = searchRoot || document.getElementById('sodo-search-root');

        if (!searchRoot || typeof MutationObserver !== 'function') {
            return;
        }

        lastTrigger = trigger;

        if (!observer) {
            observer = new MutationObserver(handleSearchChange);
            observer.observe(searchRoot, {childList: true, subtree: true});
        }
    }, true);
})();
